export default __webpack_public_path__ + "static/media/Account Details.1bd2de92.svg";